import { render } from "./NotFoundView.vue?vue&type=template&id=4f0c9e43&scoped=true"
const script = {}

import "./NotFoundView.vue?vue&type=style&index=0&id=4f0c9e43&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0c9e43"]])

export default __exports__